import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {getCookie} from "../helpers/utils";

const API_URL = '/api/v1';
const PLAYERS_FOR_MANUAL_SET = '/tournament_available_players/?&tournament_id=';
const SET_PLAYER_MANUALLY = '/move_player_to_ds/';
@Injectable({
  providedIn: 'root'
})
export class PlayersManualSelectService {

  constructor(private http: HttpClient) { }
  private getCsrfToken(): string {
    return getCookie('csrftoken');
  }

  playersForManualSetUrl(tournamentId: number) {
    return `${API_URL}${PLAYERS_FOR_MANUAL_SET}${tournamentId}`;
  }

  getPlayersForManualSet(tournamentId: number) {
    return this.http.get(
      this.playersForManualSetUrl(tournamentId),
      {
        headers: {
          'X-CSRFToken': this.getCsrfToken(),
        }
      }
    )
  }

  certainPlayerSetUrl(tournamentId: number) {
    return `${API_URL}${SET_PLAYER_MANUALLY}${tournamentId}/`;
  }

  setCertainPlayer(tournamentId: number, player: PlayerForManualSet) {
    return this.http.put(
      this.certainPlayerSetUrl(tournamentId),
      player,
      {
        headers: {
          'X-CSRFToken': this.getCsrfToken(),
        }
      }
    );

  }
}

/**
 *  **player_id** - player identifier
 *  **ds_number** - a number of a duel which is manually tuned
 *  **ds_player_number** - player order inside duel cell (1 - top, 2 - bottom)
 */
export interface PlayerForManualSet {
  player_id: number,
  ds_num: number,
  ds_player_num: number
}
